import React from 'react';
import { NavigationDots, SocialMedia } from '../components';

const AppWrap = (Component, idName, classNames) => function HOC() {
  return (
    <div id={idName} className={`app__container ${classNames}`}>
      <SocialMedia />
      <div className="app__wrapper app__flex">
        <Component />

        <div className="copyright">
          <p className="p-text">Made with Love</p>
          <p className="p-text">By <a href='https://github.com/sourrinn' rel="noreferrer" target='_blank' style={{textDecoration: 'none', color: 'blue'}}>Sourrinn</a></p>
        </div>
      </div>
      <NavigationDots active={idName} />
    </div>
  );
};

export default AppWrap;
